<template>
	<section class="layout-primary">
		<slot>
			<transition name="none">
				<router-view />
			</transition>
		</slot>
	</section>
</template>

<script lang="ts">
	import LayoutBase from '@/Core/Layout.vue';
	import { Component } from 'vue-property-decorator';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package Layout
	 * @project ChalkySticks
	 */
	@Component
	export default class LayoutPrimary extends LayoutBase {
		// Not implemented
	}
</script>

<style lang="scss">
	.layout-primary {
		height: 100%;
		position: absolute;
		width: 100%;
	}
</style>
